<template>
    <div class="container-fluid">
        <a href="#" @click.prevent="clear" v-if="!add" class="btn btn-primary mb-3">Agregar formato <i class="ml-1 fa fa-plus"></i></a>
        <a href="#" @click.prevent="clear" v-else class="btn btn-secondary mb-3">Cancelar <i class="ml-1 fa fa-minus"></i></a>

        <format-list v-show="!add" :formats="getFormats" @edit="edit"></format-list>
        <format-form v-if="add" :_format="format" class="mt-4" @sent="add = false"></format-form>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FormatForm from './FormatForm'
import FormatList from '@/components/FormatList'
export default {
    name: "Formats",
    data: () => ({
        add: false,
        format: {},
    }),
    components: {
        FormatForm,
        FormatList
    },
    created(){
        this.fetchFormats();
    },
    computed: mapGetters(['getFormats']),
    methods: {
        clear(){
            this.add = !this.add;
        },
        edit(format){
            this.format = format;
            this.add = true;
        },
        ...mapActions(['fetchFormats'])
    }
}
</script>

<style>

</style>